<template>
  <Page>
    <template v-slot:content>
      <main id="main-content">
        <div class="howitworks-page--container">
          <Section id="header" bgColor="#002C5F">
            <div class="header">
              <Label
                class="header--subtitle"
                :styles="{ color: 'white' }"
                align="center"
                size="medium"
                bold="thin"
                >{{ $t("pages.howitworks.sections.header.subtitle") }} <br
              /></Label>
              <Heading
                class="header--title"
                :label="$t('pages.howitworks.sections.header.title')"
                tag="h1"
                weight="bold"
              />
            </div>
          </Section>
          <Section id="section-1-sub-header" class="sub-header" bgColor="white">
            <div class="header">
              <Heading
                v-if="
                  $t('pages.howitworks.sections.subHeaders[0].title') &&
                    $t('pages.howitworks.sections.subHeaders[0].title') != ''
                "
                class="sub-header-title"
                :label="$t('pages.howitworks.sections.subHeaders[0].title')"
                tag="h2"
                weight="bold"
              />
              <Label
                v-if="
                  $t('pages.howitworks.sections.subHeaders[0].subtitle') &&
                    $t('pages.howitworks.sections.subHeaders[0].subtitle') != ''
                "
                class="sub-header-subtitle"
                color="tertiary"
                align="center"
                size="small"
                bold="thin"
                >{{ $t("pages.howitworks.sections.subHeaders[0].subtitle") }}
              </Label>
            </div>
          </Section>
          <Section
            class="content-row"
            id="section-1-content-first-row"
            bgColor="white"
          >
            <div class="media-content">
              <img
                :src="
                  $t('resources.images.howitworkspage.section1') ||
                    require('./../../../assets/images/howitworks-page/find-vehicle.webp')
                "
                alt="find-vehicle"
              />
            </div>
            <div class="text-content">
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.firstRow.labels[0].title') &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[0].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.firstRow.labels[0].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.firstRow.labels[0].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[0].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.firstRow.labels[0].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.firstRow.labels[1].title') &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[1].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.firstRow.labels[1].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.firstRow.labels[1].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[1].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.firstRow.labels[1].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.firstRow.labels[2].title') &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[2].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.firstRow.labels[2].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.firstRow.labels[2].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[2].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.firstRow.labels[2].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.firstRow.labels[3].title') &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[3].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.firstRow.labels[3].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.firstRow.labels[3].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.firstRow.labels[3].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.firstRow.labels[3].description"
                    )
                  }}
                </Label>
                <Link
                  class="text-content-link"
                  :styles="{ 'justify-content': 'left' }"
                  underline
                  color="secondary"
                  size="small"
                  :label="
                    $t('pages.howitworks.sections.firstRow.labels[3].link')
                  "
                  href="#"
                  @onClick="openRetakePage"
                />
              </div>
            </div>
          </Section>
          <Button
            @onClick="onClickSearch"
            class="row-button"
            fill
            size="medium"
            uppercase
            :label="$t('pages.howitworks.buttons[0].label')"
            name="search-button"
          ></Button>

          <Section id="section-2-sub-header" class="sub-header" bgColor="white">
            <div class="header">
              <Heading
                class="sub-header-title"
                :label="$t('pages.howitworks.sections.subHeaders[1].title')"
                tag="h2"
                weight="bold"
              />
              <Label
                class="sub-header-subtitle"
                color="tertiary"
                align="center"
                size="small"
                bold="thin"
                >{{ $t("pages.howitworks.sections.subHeaders[1].subtitle") }}
              </Label>
            </div>
          </Section>
          <Section
            class="content-row"
            id="section-2-content-first-row"
            bgColor="white"
          >
            <div class="text-content">
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.secondRow.labels[0].title') &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[0].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.secondRow.labels[0].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.secondRow.labels[0].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[0].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.secondRow.labels[0].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.secondRow.labels[1].title') &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[1].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.secondRow.labels[1].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.secondRow.labels[1].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[1].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.secondRow.labels[1].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.secondRow.labels[2].title') &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[2].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.secondRow.labels[2].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.secondRow.labels[2].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[2].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.secondRow.labels[2].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.secondRow.labels[3].title') &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[3].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.secondRow.labels[3].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.secondRow.labels[3].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.secondRow.labels[3].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.secondRow.labels[3].description"
                    )
                  }}
                </Label>
              </div>
            </div>
            <div class="media-content">
              <img
                :src="
                  $t('resources.images.howitworkspage.section2') ||
                    require('./../../../assets/images/howitworks-page/lifestyle.webp')
                "
                alt="lifestyle"
              />
            </div>
          </Section>

          <Section
            id="section-3-sub-header"
            class="sub-header"
            bgColor="#E4ECF0"
          >
            <div class="header">
              <Label
                class="sub-header-title"
                color="primary"
                align="center"
                size="medium"
                bold="bold"
                >{{ $t("pages.howitworks.sections.subHeaders[2].title") }}<br
              /></Label>
              <Button
                @onClick="onClickSearch"
                class="row-button"
                fill
                size="medium"
                uppercase
                :label="
                  $t('pages.howitworks.sections.subHeaders[2].buttons[0].label')
                "
                name="search-button"
              ></Button>
            </div>
          </Section>

          <Section id="sub-header" class="sub-header" bgColor="white">
            <div class="header">
              <Heading
                v-if="
                  $t('pages.howitworks.sections.subHeaders[3].title') &&
                    $t('pages.howitworks.sections.subHeaders[3].title') != ''
                "
                class="sub-header-title"
                :label="$t('pages.howitworks.sections.subHeaders[3].title')"
                tag="h2"
                weight="bold"
              />
              <Label
                v-if="
                  $t('pages.howitworks.sections.subHeaders[3].subtitle') &&
                    $t('pages.howitworks.sections.subHeaders[3].subtitle') != ''
                "
                class="sub-header-subtitle"
                color="tertiary"
                align="center"
                size="small"
                bold="thin"
                >{{ $t("pages.howitworks.sections.subHeaders[3].subtitle") }}
              </Label>
            </div>
          </Section>
          <Section
            class="content-row"
            id="section-3-content-first-row"
            bgColor="white"
          >
            <div class="media-content">
              <img
                :src="
                  $t('resources.images.howitworkspage.section1') ||
                    require('./../../../assets/images/howitworks-page/santa-fe.webp')
                "
                alt="santa-fe"
              />
            </div>
            <div class="text-content">
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.thirdRow.labels[0].title') &&
                      $t(
                        'pages.howitworks.sections.thirdRow.labels[0].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.thirdRow.labels[0].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.thirdRow.labels[0].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.thirdRow.labels[0].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.thirdRow.labels[0].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.thirdRow.labels[1].title') &&
                      $t(
                        'pages.howitworks.sections.thirdRow.labels[1].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.thirdRow.labels[1].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.thirdRow.labels[1].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.thirdRow.labels[1].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.thirdRow.labels[1].description"
                    )
                  }}
                </Label>
              </div>
              <div class="content">
                <Heading
                  v-if="
                    $t('pages.howitworks.sections.thirdRow.labels[2].title') &&
                      $t(
                        'pages.howitworks.sections.thirdRow.labels[2].title'
                      ) != ''
                  "
                  class="text-content-title"
                  :label="
                    $t('pages.howitworks.sections.thirdRow.labels[2].title')
                  "
                  tag="h3"
                  weight="bold"
                />
                <Label
                  v-if="
                    $t(
                      'pages.howitworks.sections.thirdRow.labels[2].description'
                    ) &&
                      $t(
                        'pages.howitworks.sections.thirdRow.labels[2].description'
                      ) != ''
                  "
                  class="text-content-subtitle"
                  color="tertiary"
                  align="left"
                  size="x-small"
                  bold="thin"
                  >{{
                    $t(
                      "pages.howitworks.sections.thirdRow.labels[2].description"
                    )
                  }}
                </Label>
              </div>
            </div>
          </Section>
        </div>
      </main>
    </template>
  </Page>
</template>

<script>
import { Page } from "../../templates";
import { Section, Label, Link, Button } from "../../atoms";
import { mapGetters } from "vuex";
import { Heading } from "@sc/ds-ui-component-library";
import { PAGES } from "@/enums/pages";

export default {
  components: {
    Button,
    Label,
    Link,
    Page,
    Section,
    Heading
  },
  data() {
    return {};
  },
  metaInfo() {
    return {
      title: this.$t("meta.howItWorks.title"),
      meta: [
        {
          name: "description",
          content: this.$t("meta.howItWorks.description")
        },
        {
          name: "keywords",
          content: this.$t("meta.howItWorks.keywords")
        },
        {
          property: "og:title",
          content: this.$t("meta.howItWorks.title")
        },
        {
          property: "og:description",
          content: this.$t("meta.howItWorks.description")
        },
        {
          property: "og:url",
          content: window.location.href
        },
        {
          property: "og:image",
          content: this.$t("meta.howItWorks.image")
        }
      ]
    };
  },
  methods: {
    onClickSearch() {
      this.$router.push({
        name: PAGES.SEARCH
      });
    },
    openRetakePage() {
      this.$router.push({
        name: PAGES.RETAKE
      });
    }
  },
  computed: {
    ...mapGetters(["getToken", "getLoadingAuthentication"])
  }
};
</script>

<style lang="css" scoped src="./HowItWorksPage.css"></style>
